import React, { SyntheticEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, helperMargin, Box } from '@utex/ui-kit';

interface Props {
  openDeposit: () => void;
  openWithdraw: () => void;
}

export const DepositButtons = (props: Props) => {
  const { openDeposit, openWithdraw, ...other } = props;
  const { t } = useTranslation('sideMenu');

  return (
    <Box display="flex" margin={[0, 24]} {...other}>
      <Button
        view="primary-dim"
        css={helperMargin({ right: 10 })}
        onClick={(e: SyntheticEvent) => {
          e.preventDefault();
          openDeposit();
        }}
        data-testid="deposit-btn"
      >
        {t('Deposit')}
      </Button>
      <Button
        view="extra-dim"
        onClick={(e: SyntheticEvent) => {
          e.preventDefault();
          openWithdraw();
        }}
        data-testid="withdraw-btn"
      >
        {t('Withdraw')}
      </Button>
    </Box>
  );
};
